<div class="loader center">
  <mat-spinner></mat-spinner>
</div>